<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useCustomerCommentsFilters } from '../../model/comments/customer-comments-filters.hook'

defineOptions({
  name: 'CustomerCommentsFilters',
})

const {
  refOptions,
  refInitialValue,
  isLoading,
  setSelected,
  submitSearch,
  clearFilters,
} = useCustomerCommentsFilters()
</script>

<template>
  <FiltersBar
    class="customer-comments-filters"
    :loading="isLoading"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <MultiSelectSearchable
        :key="`disciplines-${refOptions.length}-${refInitialValue.join()}`"
        class="customer-comments-filters__disciplines"
        label="Disciplines"
        placeholder="All"
        :options="refOptions"
        :value="refInitialValue"
        is-all-available
        :disabled="isLoading"
        @selected="setSelected"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./CustomerCommentsFilters.scss" />
